import React from 'react'
import styles from '../../styles/components/Spinner.module.sass'

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  color?: string
  className?: string
}

/**
 * Spinner component for displaying a loading indicator.
 *
 * @param param0 - The props for the component.
 * @returns The rendered Spinner component.
 *
 * @example
 * <Spinner size="lg" color="#3498db" />
 */
const Spinner: React.FC<SpinnerProps> = ({ size = 'sm', color="#FFFFFF", className = "" }) => {
    return (
        <div
            className={`${styles['spinner']} ${styles[size]} ${className}`}
            style={{ borderTopColor: color }}
            role="status"
            aria-label="Loading..."
        />
    )
}

export default Spinner